var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSourcingCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 19.5,
    r: 19.5,
    fill: "#444444"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4844 19.9844L24.8594 16.6406C25.0469 16.4531 25.0469 16.1094 24.8594 15.9219L24.0781 15.1406C23.8906 14.9531 23.5469 14.9531 23.3594 15.1406L20.0156 18.5156L16.6406 15.1406C16.4531 14.9531 16.1094 14.9531 15.9219 15.1406L15.1406 15.9219C14.9531 16.1094 14.9531 16.4531 15.1406 16.6406L18.5156 19.9844L15.1406 23.3594C14.9531 23.5469 14.9531 23.8906 15.1406 24.0781L15.9219 24.8594C16.1094 25.0469 16.4531 25.0469 16.6406 24.8594L20.0156 21.4844L23.3594 24.8594C23.5469 25.0469 23.8906 25.0469 24.0781 24.8594L24.8594 24.0781C25.0469 23.8906 25.0469 23.5469 24.8594 23.3594L21.4844 19.9844Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSourcingCloseIcon);
export default __webpack_public_path__ + "static/media/sourcing-close-icon.f0bd6fb5b1480170a0eae1d77f9db6f7.svg";
export { ForwardRef as ReactComponent };